import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  Aangifte, BokkzAlgDataService, IncomeTaxEntity,
  LoonInternationaleOrganisatie,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import { RadioButtonItem, SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { BehaviorSubject, filter, Subscription } from "rxjs";
import {SPINNER_TIMEOUT} from "../../../gedeelde-componenten/gedeelde-componenten.component";
import { Event, NavigationEnd, Router } from "@angular/router";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-loon-internationale-organisatie',
  templateUrl: './loon-internationale-organisatie.component.html',
  styleUrls: ['./loon-internationale-organisatie.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class LoonInternationaleOrganisatieComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;

    @Input() public id!: string;
    public clientId!: string;

    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    public partnerBoolean = {} as boolean;
    @Input() partner = new BehaviorSubject<boolean>(false);
    private partnerAangifte = {} as Aangifte

    public isDefAangifte = {} as boolean;

    private focusedElementId: string | null = null;

    public loonInternationaleOrganisatie = {} as FormGroup

    public itemsJaNee = [
        new RadioButtonItem<boolean>(true, "Ja"),
        new RadioButtonItem<boolean>(false, "Nee"),
    ];

    public optionsTegenwoordig: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Tegenwoordige dienstbetrekking"},
        {value: false, label: "Vroegere dienstbetrekking"},
    ];

    public optionsZvw: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Nederland"},
        {value: false, label: "Ander land"},
    ];

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router,private fb: FormBuilder) {
        this.loonInternationaleOrganisatie = this.fb.group({
            loonVanInternationaleOrganisatie:
                this.fb.array<LoonInternationaleOrganisatie>([])
        })
    }

    get loonVanInternationaleOrganisatie(): FormArray {
        return this.loonInternationaleOrganisatie.get('loonVanInternationaleOrganisatie') as FormArray;
    }

    addRijLoonInternationaleOrganisatie(): void {
        this.loonVanInternationaleOrganisatie.push(this.createLoonInternationaleOrganisatieFormGroup()
        )
    }

    verwijderRijLoonInternationaleOrganisatie(index: number): void {
        this.loonVanInternationaleOrganisatie.removeAt(index);
        this.loonInternationaleOrganisatie.updateValueAndValidity()
        this.loonInternationaleOrganisatie.markAsDirty()
        this.saveForm();
    }

    createLoonInternationaleOrganisatieFormGroup(loon?: LoonInternationaleOrganisatie): FormGroup {
        return this.fb.group(({
            loon: this.fb.group(({
                omschrijving: loon ? loon.loon.omschrijving : undefined,
                bedrag: loon ? loon.loon.bedrag : null
            } as OmschrijvingEnBedrag)),
            loonheffing: loon ? loon.loonheffing : null,
            loonsoort: loon ? loon.loonsoort : null,
            tegenwoordigeDienstbetrekking: loon ? loon.tegenwoordigeDienstbetrekking : undefined,
            deelPremieloonVolksverzekeringen: loon ? loon.deelPremieloonVolksverzekeringen : null,
            afdrachtZVWinNLmoetnog: loon ? loon.afdrachtZVWinNLmoetnog : undefined,
        } as LoonInternationaleOrganisatie))
    }


    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
       this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte;
                this.aangifte = aangifte;
                this.partnerAangifte = aangifte.partnerAangifte ? aangifte.partnerAangifte : {} as Aangifte;
                this.updateForm();
                this.partner.subscribe((partner) => {
                    this.partnerBoolean = partner
                    this.loonInternationaleOrganisatie.reset()
                    this.updateForm();
                });
            }
        });
      this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) =>{
        this.clientId=client.sstRelationId!;
      })
      this.routerSubscription = this.router.events
        .pipe(
          filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this.handleUrlChange(event.urlAfterRedirects);
        });
    }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
    }
    if (this.incomeTaxEntitySubscription) {
      this.incomeTaxEntitySubscription.unsubscribe();
    }
    if (this.clientEntitySubscription) {
      this.clientEntitySubscription.unsubscribe();
    }
      if (this.isDefAangifteSubscription) {
          this.isDefAangifteSubscription.unsubscribe();
      }
  }

  handleUrlChange(newUrl: string) {
    if (!this.isSaving && this.hasUnsavedChanges()) {
      this.isSaving = true;
      this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
      this.isSaving = false;
    }
  }

  private hasUnsavedChanges(): boolean {
    return this.loonInternationaleOrganisatie.dirty;
  }

    private updateForm(): void {
        let loonInternationaalLijst = this.aangifte?.box1?.belastbaarLoon?.vrijgesteldLoonInternationaleOrganisatie || [];
        this.partner.subscribe((partner) => {
            if (partner) {
                loonInternationaalLijst = this.aangifte?.partnerAangifte?.box1?.belastbaarLoon?.vrijgesteldLoonInternationaleOrganisatie || [];
            }
        });

        const formArray = this.loonInternationaleOrganisatie.get('loonVanInternationaleOrganisatie') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > loonInternationaalLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Add or update controls
        for (let i = 0; i < loonInternationaalLijst.length; i++) {
            if (i < formArray.length) {
                // Update existing control
                const control = formArray.at(i) as FormGroup;
                control.patchValue(loonInternationaalLijst[i]);
            } else {
                // Add new control
                const formGroup = this.createLoonInternationaleOrganisatieFormGroup(loonInternationaalLijst[i]);
                formArray.push(formGroup);
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        if (!this.partnerBoolean) {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                box1: {
                    ...this.aangifte.box1,
                    belastbaarLoon: {
                        ...this.aangifte.box1?.belastbaarLoon,
                        vrijgesteldLoonInternationaleOrganisatie: this.loonInternationaleOrganisatie.value.loonVanInternationaleOrganisatie
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);

        } else {
            this.incomeTaxEntity.aangifte = {
                ...this.aangifte,
                partnerAangifte: {
                    ...this.aangifte.partnerAangifte,
                    box1: {
                        ...this.aangifte.partnerAangifte?.box1,
                        belastbaarLoon: {
                            ...this.aangifte.partnerAangifte?.box1?.belastbaarLoon,
                            vrijgesteldLoonInternationaleOrganisatie: this.loonInternationaleOrganisatie.value.loonVanInternationaleOrganisatie
                        }
                    },
                },
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }
        this.loonInternationaleOrganisatie.markAsDirty()
    }
}
